export interface AdminSessionState {
  loggedIn: boolean
  isAdmin: boolean
  user: {
    email: string
    name?: string
    picture?: string
  } | null
}

export function useAdminSession() {
  const { data, refresh } = useFetch<AdminSessionState>('/api/admin/session', {
    default: () => ({ loggedIn: false, isAdmin: false, user: null }),
  })

  return {
    session: data,
    loggedIn: computed(() => Boolean(data.value?.loggedIn)),
    isAdmin: computed(() => Boolean(data.value?.isAdmin)),
    refresh,
  }
}
